import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'

export const useAnimatedMesh = () => {
  const meshRef = useRef()

  useFrame(({ clock }) => {
    if (meshRef.current) {
      meshRef.current.rotation.x += 0.01
      meshRef.current.rotation.y += 0.01
    }
  })

  return meshRef
}
